export class ProductFile {
    bytes: any;
    type: string;

    constructor(bytes: any, type: string) {
        this.bytes = bytes;
        this.type = type;
    }
}
